import { Injectable } from '@angular/core';
import { API_METHODS, API_URL } from 'common/constants/sm-constants';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { SystemService } from 'common/services/core-services/system.service';
import { environment } from 'src/environments/environment';
import { FormDataService } from '../../base-data-services/form-data.service';
import { AddInternShipModel } from 'common/models/page-models/Student Internship List/Add intership/add-internship-data-model';
import moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class AddInternshipFormDataService extends FormDataService<AddInternShipModel> {
  constructor(http: SmApiService, protected override ss: SystemService) {
    super(API_URL.AddInternship, http, ss);
  }

  // Add first AddInternship url path in Sm-const

  override getUpdatePayload(data) {
    let payload;
    // console.log(data, '===');

    payload = {
      InternshipCode: data.internshipCode,
    };
    
    return payload;
  }

  override getEditUrlAndMethod() {
    const edit = {
      url: environment.apiUrl + API_URL.intershipDetails,
      method: API_METHODS.post,
    };
    return edit;
  }

  override getUpdateUrl(data = null) {
    return API_URL.AddInternship;
  }

  createInstance(): AddInternShipModel {
    return new AddInternShipModel();
  }

  override modifyAPIResponse(response: any) {
    // console.log("RESPONSE", response);
    const dataModel = this.createInstance();
    dataModel.year = response.details[0].considerYear;
    dataModel.internshipTitle = response.details[0].internshipTitle;
    // dataModel.internshipStartDate = response?.details[0]?.internshipStartDate ? this.formatDate(response.details[0].internshipStartDate): "";
    dataModel.internshipStartDate = response?.details[0]?.internshipStartDate ? new Date(response.details[0].internshipStartDate): "";
    // dataModel.internshipEndDate = response?.details[0]?.internshipEndDate ? this.formatDate(response.details[0].internshipEndDate) : "";
    dataModel.internshipEndDate = response?.details[0]?.internshipEndDate ? new Date(response.details[0].internshipEndDate) : "";
    dataModel.internshipCompanyId = response.details[0].internshipCompanyId
    dataModel.internshipCompanyLocationId = response.details[0].internshipCompanyLocationId;
    dataModel.Address = response.details[0].location_address;
    dataModel.accommodationAddress = response?.details[0]?.accommodationAddress ? response.details[0].accommodationAddress : "";
    dataModel.accommodationContactPerson = response?.details[0]?.accommodationContactPerson ? response.details[0].accommodationContactPerson : "";
    dataModel.internshipProjectName = response?.details[0]?.internshipProjectName ? response.details[0].internshipProjectName : "";
    dataModel.internshipCompanyMentorId = response?.details[0]?.internshipCompanyMentorId ;
    dataModel.mentorEmail = response?.details[0]?.mentorEmail ?  response.details[0].mentorEmail : "";
    dataModel.mentorPhone = response?.details[0]?.mentorPhone ?  response.details[0].mentorPhone : "";
    dataModel.guideName = response?.details[0]?.guideName ?  response.details[0].guideName : "";
    dataModel.guideEmail = response?.details[0]?.guideEmail ?  response.details[0].guideEmail : "";
    dataModel.guideMobile = response?.details[0]?.guideMobile ?  response.details[0].guideMobile : "";
    dataModel.hrName = response?.details[0]?.hrName ?  response.details[0].hrName : "";
    dataModel.hrEmail = response?.details[0]?.hrEmail ?  response.details[0].hrEmail : "";
    dataModel.hrMobile = response?.details[0]?.hrMobile ?  response.details[0].hrMobile : "";
    dataModel.student_ids = response?.details ?  response.details.map((student)=> student.studentId) : "";
    dataModel.id = response?.details[0]?.internshipMasterId ? response.details[0].internshipMasterId : "";
    dataModel.student_options = response?.details.map((student)=> ({studentId:student.studentId, name:student.orgname}))
    return dataModel;
  }

  formatDate(dateValue) {
    // console.log("DATE VALUE", dateValue);
    
    if (!dateValue || dateValue === 0) {
      return '';
    }
    const formattedDate = moment(dateValue).format('DD/MM/YYYY');
    return moment(formattedDate, 'DD/MM/YYYY').isValid() ? formattedDate : '';
  }

  override beforePostData(
    model: any,
    metamodel: any,
    dataModel: any
  ): Promise<AddInternShipModel> {
    return new Promise((resolve, reject) => {
      const submitData: any = {};
    //   submitData.considerYear = model.year;
    // console.log("MODEL",model, metamodel, dataModel);
    
      submitData.considerYear = model.year;
      if (model.id) {
        submitData.id = model.id;
      }
      submitData.internshipTitle = model.internshipTitle;

      if(model.internshipEndDate < model.internshipStartDate){
        this.ss.showError("End Date cannot be smaller than Start Date.")
        return;
      }
      
      submitData.internshipStartDate = moment(model.internshipStartDate).format(
        'DD/MM/YYYY'
      );
      submitData.internshipEndDate = moment(model.internshipEndDate).format(
        'DD/MM/YYYY'
      );
      submitData.internshipProjectName = model.internshipProjectName
      // submitData.internshipStartDate = (model.internshipStartDate)
      // submitData.internshipEndDate = (model.internshipEndDate)
      // submitData.internshipStartDate = model.internshipStartDate
      // submitData.internshipEndDate = model.internshipEndDate
      submitData.internshipCompanyId = model.internshipCompanyId;
      submitData.internshipCompanyLocationId = model.internshipCompanyLocationId;
      if (model.accommodationAddress) {
        submitData.accommodationAddress = model.accommodationAddress;
      }
      if (model.accommodationContactPerson) {
        submitData.accommodationContactPerson =
          model.accommodationContactPerson;
      }
      submitData.internshipCompanyMentorId = model.internshipCompanyMentorId;

      if (model.guideName) {
        submitData.guideName = model.guideName;
      }
      if (model.guideEmail) {
        submitData.guideEmail = model.guideEmail;
      }

      if (model.guideMobile) {
        submitData.guideMobile = model.guideMobile;
      }
      if (model.hrName) {
        submitData.hrName = model.hrName;
      }
      if (model.hrEmail) {
        submitData.hrEmail = model.hrEmail;
      }

      if (model.hrMobile) {
        submitData.hrMobile = model.hrMobile;
      }

      submitData.student_ids = model.student_ids;
      // console.log("Submit Data", submitData);
      
      resolve(submitData);
    });
  }
}

export { FormDataService };
